/*
 * @Description:
 * @Date: 2022-05-31 16:50:30
 */
import createExtend from '@/components/createExtend.js';
import subAccountMgmt from '@/page/home/child/subAccountMgmt';
import { setStorage } from '@/tools/storage';
import vue2Store from '@/store/index';
import { batchConfirmProject } from '@/api/ajax';
export const middlewareHomeProject = {
  setHomeProjectInfo: async (item, customQuery = {}) => {
    // 审核项目，进行下一个项目时需要使用到
    setStorage('home-search-query', customQuery);

    // 项目主要参数
    await vue2Store.dispatch('setHomeQuery', item);

    return {
      ...vue2Store.state.homeProject,
      localCache: ''
    };
  },
  // 让我偷个懒吧，不然要在vue3中重写权限配置弹窗
  powerMgmt(item, onUpdated = () => {}) {
    createExtend(subAccountMgmt, {
      data: item
    }).$on('updated', () => {
      onUpdated && onUpdated();
    });
  },
  // 因为提示的原因
  batchConfirmProject(ids) {
    return batchConfirmProject({
      projectIds: ids
    });
  }
};
